<div class="td-loading-container" *ngIf="loadingSpinner">
  <mat-spinner class="td-loading"></mat-spinner>
</div>
<h2>User Login</h2>
  <div class="td-login-assist-text">
    <p>Please enter a new password to continue.</p>
  </div>
  <form [formGroup]="tdNewPasswordForm">
    <div class="td-form-row" *ngIf="!userLoggedIn">
      <mat-form-field class="td-full-form" >
      <mat-label>
        <fa-icon icon="envelope"></fa-icon>
        Email
      </mat-label>
      <input matInput formControlName="tdEmail" required type="email" aria-label="Email Address" autofocus>
        <mat-hint>This will also be your username when logging in</mat-hint>
        <mat-error *ngIf="!tdNewPasswordForm.get('tdEmail').hasError('required')&&tdNewPasswordForm.get('tdEmail').hasError('email')">Please enter a valid email</mat-error>
        <mat-error *ngIf="tdNewPasswordForm.get('tdEmail').hasError('required')">Please enter an email</mat-error>
      </mat-form-field>
    </div>
    <div class="td-form-row" *ngIf="!userLoggedIn">
      <mat-form-field class="td-full-form">
        <mat-label>
          <fa-icon icon="lock"></fa-icon>
          Temporary Password
        </mat-label>
        <input matInput formControlName="tdTempPassword"  [type]="hideTempPassWord ? 'password' : 'text'" required aria-label="Temporary Password">
        <mat-hint>Enter the password you received in your email.</mat-hint>
        <button mat-icon-button type="button" matSuffix (click)="hideTempPassWord = !hideTempPassWord" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideTempPassWord" tabindex="-1">
          <mat-icon>{{hideTempPassWord ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="td-form-row">
      <mat-form-field class="td-full-form">
        <mat-label>
          <fa-icon icon="lock"></fa-icon>
          Password
        </mat-label>
        <input matInput 
               formControlName="tdPassword"  
               [type]="hidePassWord ? 'password' : 'text'" 
               required 
               minlength="{{loginRegistrationOptions.passwordMinCharLength}}" 
               maxlength="65" 
               aria-label="Password">
  
        <button mat-icon-button matSuffix (click)="hidePassWord = !hidePassWord" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassWord" tabindex="-1" type="button" >
          <mat-icon>{{hidePassWord ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="tdNewPasswordForm.get('tdPassword').hasError('required')">Please enter a password</mat-error>
        <mat-error *ngIf="tdNewPasswordForm.hasError('sameTemp')">Password can not be the same as the temporary password.</mat-error>

      </mat-form-field>
    </div>
    <div class="td-form-row">
      <mat-form-field class="td-full-form" >
        <mat-label>
          <fa-icon icon="lock"></fa-icon>
          Password Confirmation
        </mat-label>
        <input matInput formControlName="tdPasswordConfirm"  [type]="hidePassWordConfirm ? 'password' : 'text'" required aria-label="Confirm Password">
        <button mat-icon-button matSuffix (click)="hidePassWordConfirm = !hidePassWordConfirm" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassWord" tabindex="-1" type="button" >
          <mat-icon>{{hidePassWordConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngIf="tdNewPasswordForm.get('tdPasswordConfirm').hasError('minLength')">Passwords must have length of at least {{loginRegistrationOptions.passwordMinCharLength}} characters</mat-error>
        <mat-error *ngIf="tdNewPasswordForm.get('tdPasswordConfirm').hasError('notMatch')">Passwords must match</mat-error>
        
      </mat-form-field>
    </div>
    <div class="td-form-row td-pw-hint-container">
      <span class="td-pw-hint" 
            *ngIf="loginRegistrationOptions.passwordMinCharLength > 0" 
            [class.td-pw-null]="tdNewPasswordForm.get('tdPassword').value === ''"
            [class.td-pw-good]="tdNewPasswordForm.get('tdPassword').value !== '' && !tdNewPasswordForm.get('tdPassword').hasError('minlength')"
            [class.td-pw-bad]="tdNewPasswordForm.get('tdPassword').hasError('minlength')">
        <span *ngIf="tdNewPasswordForm.get('tdPassword').value === ''"><fa-icon [icon]="['far','circle']"></fa-icon></span>
        <span *ngIf="tdNewPasswordForm.get('tdPassword').value !== '' && !tdNewPasswordForm.get('tdPassword').hasError('minlength')"><fa-icon [icon]="['far','check-circle']" aria-label="Password meets requirement"></fa-icon></span>
        <span *ngIf="tdNewPasswordForm.get('tdPassword').hasError('minlength')"><fa-icon [icon]="['far','times-circle']" aria-label="Password doesn't meet requirement"></fa-icon></span>
        Password requires a min. length of {{loginRegistrationOptions.passwordMinCharLength}}
      </span>
      <span class="td-pw-hint"  
            *ngIf="loginRegistrationOptions.requirePasswordCharacter"
            [class.td-pw-null]="tdNewPasswordForm.get('tdPassword').value === ''"
            [class.td-pw-good]="!tdNewPasswordForm.get('tdPassword').hasError('pwNoSC') && tdNewPasswordForm.get('tdPassword').value !== ''"
            [class.td-pw-bad]="tdNewPasswordForm.get('tdPassword').hasError('pwNoSC') && tdNewPasswordForm.get('tdPassword').value !== ''">
          <span *ngIf="tdNewPasswordForm.get('tdPassword').value === ''"><fa-icon [icon]="['far','circle']"></fa-icon></span>
          <span *ngIf="!tdNewPasswordForm.get('tdPassword').hasError('pwNoSC') && tdNewPasswordForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','check-circle']" aria-label="Password meets requirement"></fa-icon></span>
          <span *ngIf="tdNewPasswordForm.get('tdPassword').hasError('pwNoSC') && tdNewPasswordForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','times-circle']" aria-label="Password doesn't meet requirement"></fa-icon></span>
          Password requires special character</span>
      <span class="td-pw-hint"  
            *ngIf="loginRegistrationOptions.requirePasswordNumber"
            [class.td-pw-null]="tdNewPasswordForm.get('tdPassword').value === ''"
            [class.td-pw-good]="!tdNewPasswordForm.get('tdPassword').hasError('pwNoNumber') && tdNewPasswordForm.get('tdPassword').value !== ''"
            [class.td-pw-bad]="tdNewPasswordForm.get('tdPassword').hasError('pwNoNumber') && tdNewPasswordForm.get('tdPassword').value !== ''">
          <span *ngIf="tdNewPasswordForm.get('tdPassword').value === ''"><fa-icon [icon]="['far','circle']"></fa-icon></span>
          <span *ngIf="!tdNewPasswordForm.get('tdPassword').hasError('pwNoNumber') && tdNewPasswordForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','check-circle']" aria-label="Password meets requirement"></fa-icon></span>
          <span *ngIf="tdNewPasswordForm.get('tdPassword').hasError('pwNoNumber') && tdNewPasswordForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','times-circle']" aria-label="Password doesn't meet requirement"></fa-icon></span>
          Password requires number</span>
      <span class="td-pw-hint"  
            *ngIf="loginRegistrationOptions.requirePasswordMixedCase"
            [class.td-pw-null]="tdNewPasswordForm.get('tdPassword').value === ''"
            [class.td-pw-good]="!tdNewPasswordForm.get('tdPassword').hasError('pwNoMixed') && tdNewPasswordForm.get('tdPassword').value !== ''"
            [class.td-pw-bad]="tdNewPasswordForm.get('tdPassword').hasError('pwNoMixed') && tdNewPasswordForm.get('tdPassword').value !== ''">
          <span *ngIf="tdNewPasswordForm.get('tdPassword').value === ''"><fa-icon [icon]="['far','circle']"></fa-icon></span>
          <span *ngIf="!tdNewPasswordForm.get('tdPassword').hasError('pwNoMixed') && tdNewPasswordForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','check-circle']" aria-label="Password meets requirement"></fa-icon></span>
          <span *ngIf="tdNewPasswordForm.get('tdPassword').hasError('pwNoMixed') && tdNewPasswordForm.get('tdPassword').value !== ''"><fa-icon [icon]="['far','times-circle']" aria-label="Password doesn't meet requirement"></fa-icon></span>
      Password required the use of Uppercase and Lowercase characters</span>
  </div>
  
    <button mat-flat-button type="submit" class="td-form-updatepassword-button"  [style.background-color]="tdNewPasswordForm.invalid ? null : primaryColor" (click)="userPasswordUpdate()" [disabled]="loadingSpinner || tdNewPasswordForm.invalid"  aria-label="Update Password">Update Password</button>
  </form>